import React from 'react';
import { Users, TrendingUp, Star, Activity, Zap, DollarSign, Award } from 'lucide-react';

interface StatsCardsProps {
  activeMembers: number;
  totalMembers: number;
  totalRevenue: number;
  newThisMonth: number;
}

const StatsCards: React.FC<StatsCardsProps> = ({ activeMembers, totalMembers, totalRevenue, newThisMonth }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-500 text-sm font-semibold uppercase tracking-wider">Active Members</p>
          <p className="text-3xl font-bold text-gray-900 mt-2 tracking-tight">{activeMembers}</p>
          <div className="flex items-center mt-3">
            <TrendingUp className="h-4 w-4 text-green-600 mr-2" />
            <span className="text-green-600 text-sm font-medium">+12% from last month</span>
          </div>
        </div>
        <div className="p-3 bg-green-50 rounded-xl">
          <Users className="h-8 w-8 text-green-600" />
        </div>
      </div>
    </div>
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-500 text-sm font-semibold uppercase tracking-wider">Total Members</p>
          <p className="text-3xl font-bold text-gray-900 mt-2 tracking-tight">{totalMembers}</p>
          <div className="flex items-center mt-3">
            <Star className="h-4 w-4 text-blue-600 mr-2" />
            <span className="text-blue-600 text-sm font-medium">Premium community</span>
          </div>
        </div>
        <div className="p-3 bg-blue-50 rounded-xl">
          <Activity className="h-8 w-8 text-blue-600" />
        </div>
      </div>
    </div>
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-500 text-sm font-semibold uppercase tracking-wider">Monthly Revenue</p>
          <p className="text-3xl font-bold text-gray-900 mt-2 tracking-tight">₹{totalRevenue.toLocaleString()}</p>
          <div className="flex items-center mt-3">
            <Zap className="h-4 w-4 text-amber-600 mr-2" />
            <span className="text-amber-600 text-sm font-medium">+8% growth</span>
          </div>
        </div>
        <div className="p-3 bg-amber-50 rounded-xl">
          <DollarSign className="h-8 w-8 text-amber-600" />
        </div>
      </div>
    </div>
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-500 text-sm font-semibold uppercase tracking-wider">New This Month</p>
          <p className="text-3xl font-bold text-gray-900 mt-2 tracking-tight">{newThisMonth}</p>
          <div className="flex items-center mt-3">
            <Award className="h-4 w-4 text-purple-600 mr-2" />
            <span className="text-purple-600 text-sm font-medium">Fresh recruits</span>
          </div>
        </div>
        <div className="p-3 bg-purple-50 rounded-xl">
          <TrendingUp className="h-8 w-8 text-purple-600" />
        </div>
      </div>
    </div>
  </div>
);

export default StatsCards;
